import React from "react";
import Text from "@/components/ui/text";
import { DreamhubGradient, InfoCircle } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { Switch } from "@/components/ui/switch";
import { APIFieldItem } from "@/pages/settings/types";

interface FieldPopulationProps {
  fieldData: APIFieldItem;
  onFilledByDreamerChange: (filledByDreamer: boolean) => void;
}

export const FieldPopulation: React.FC<FieldPopulationProps> = ({
  fieldData,
  onFilledByDreamerChange
}) => {
  return (
    <div className="flex flex-col gap-2">
      <Text variant="bodySecondary">{"Field population"}</Text>
      <div className="relative rounded-lg p-[1px]">
        <div
          className="absolute inset-0 rounded-lg"
          style={{
            background:
              "linear-gradient(135deg, rgba(0, 245, 163, 0.4) 0%, rgba(77, 166, 255, 0.4) 50%, rgba(0, 26, 51, 0.4) 100%)"
          }}
        />
        <div
          className="relative flex flex-row justify-between items-center px-4 py-3 rounded-lg"
          style={{
            background: `radial-gradient(ellipse 235.44% 233.67% at 76.69% 149.84%, rgba(112, 243, 176, 0.15) 0%, rgba(0, 85, 255, 0.2) 4%, rgba(4, 7, 11, 0) 52%), #0D1520`
          }}
        >
          <div className="flex gap-2 items-center">
            <DreamhubGradient />
            <Text variant="body">{"Auto update by Dreamer"}</Text>
            <IconContainer color="secondary">
              <InfoCircle />
            </IconContainer>
          </div>

          <Switch
            checked={fieldData.filledByDreamer}
            onCheckedChange={onFilledByDreamerChange}
          />
        </div>
      </div>
    </div>
  );
};
